import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import SvgIcon from '@jamescoyle/vue-icon';
import { registerComponents } from './plugins/loaderBaseComponents';
import { setConfi18n } from './plugins/i18n';
import VueAnimXyz from '@animxyz/vue3';

import '@animxyz/core'; // Import css here if you haven't elsewhere
import './assets/tailwind-style.css';

//** analytics */
import VueGtag from 'vue-gtag-next';

import gads from '@/plugins/gads';

const app = createApp(App);

registerComponents(app);

app.component('svg-icon', SvgIcon);

app
  .use(store)
  .use(router)
  .use(VueAnimXyz)
  .use(setConfi18n())
  .use(gads, {
    property_id: 'AW-10878162560',
    conversion_track_id: 'AW-10878162560/L-gnCO_lwK8DEICtjsMo'
  })
  .use(VueGtag, {
    property: { id: 'G-KVV8MXMDHS' },
    router
  })
  .mount('#app');

app.provide('$gtag', app.config.globalProperties.$gtag);
